import Flag from "../Flag";
import { COUNTRIES, currencyFor } from "../../lib/countries";

/**
 * One row of the per-country compensation input as used in the admin
 * Study modal. Renders:
 *   [🇬🇧 United Kingdom] [£][__ numeric amount __]
 *
 * The currency symbol is a non-editable prefix inside the input box,
 * driven entirely by the country , the admin only types the number.
 * `value` is the raw stored amount (e.g. "100"); the public site
 * prepends the symbol itself on display.
 */
export default function CompensationAmountInput({
  country,
  value,
  onChange,
  required = false,
  testId,
}) {
  const code = COUNTRIES.find((x) => x.name === country)?.code;
  const { symbol } = currencyFor(country);
  // Width of the symbol pill is keyed off character count so "CHF " /
  // "AED " don't crowd the cursor.
  const symLen = symbol.trim().length;
  const symWidthPx = Math.max(28, 16 + symLen * 9);

  return (
    <div className="flex items-center gap-3">
      <div className="w-44 flex items-center gap-2 text-sm text-[var(--charcoal)] font-medium flex-shrink-0">
        <Flag code={code} size="sm" />
        <span className="truncate">{country}</span>
      </div>
      <div className="relative flex-1">
        {symbol && (
          <span
            aria-hidden="true"
            className="absolute left-0 top-0 bottom-0 flex items-center justify-center text-sm font-semibold text-[var(--text-muted)] pointer-events-none border-r border-[var(--sage)]/15"
            style={{ width: symWidthPx }}
          >
            {symbol.trim()}
          </span>
        )}
        <input
          type="text"
          inputMode="decimal"
          value={value || ""}
          onChange={(e) => onChange?.(e.target.value)}
          className="w-full h-10 pr-4 rounded-lg border border-[var(--sage)]/20 focus:border-[var(--sage)] focus:ring-2 focus:ring-[var(--sage)]/20"
          style={{ paddingLeft: symbol ? symWidthPx + 8 : 16 }}
          data-testid={testId}
          required={required}
        />
      </div>
    </div>
  );
}
